import { SetStateAction } from "react";
import useSectionBox from "./useSectionBox";
import { stdObject } from "../../../data/types/stdObject";
import BasicInput from "../../BasicInput";
import { useTranslation } from "react-i18next";
import BasicButton from "../../BasicButton";
import { useStationeryContext } from "../../../context/MainContext";
import EditorBox from "./EditorBox";
import CheckRow from "./CheckRow";

export default function SectionBox({ listItems }: stdObject) {
  const { t } = useTranslation();

  const {
    selectRow,
    inputTypeValid,
    inputValueValid,
    suffixType,
    innerStyleType,
  } = useSectionBox();

  const { tabIndex, isPrint, isDoc, hasTicket, paperData, handleActive } =
    useStationeryContext();

  return (
    <div className="docExtraContent" style={{ width: 400 }}>
      <div style={{ flex: 1, overflowY: "auto" }}>
        <table className="noSelect" width={"100%"} cellSpacing={0}>
          <tbody>
            {listItems[!isDoc && tabIndex === 3 ? 4 : tabIndex]
              .filter((e: stdObject) => e)
              .map((e: any, index: number) => {
                return !hasTicket && (tabIndex === 0 || e.type === "label") ? (
                  ((paperData.data.TIPDOC === "SEV" && e.code === "ADSDOC") ||
                    e.code !== "ADSDOC") && (
                    <BasicInput
                      key={index}
                      label={e.label ?? t(`s.${e.code}`)}
                      isTable={true}
                      type={inputTypeValid(e)}
                      value={inputValueValid(e.code)}
                      options={e.options}
                      suffix={suffixType(e)}
                      style={e.style}
                      innerStyle={innerStyleType(e)}
                      onChange={(v: {
                        target: { value: SetStateAction<string> };
                      }) => selectRow(e, v.target.value)}
                    />
                  )
                ) : (
                  <CheckRow key={index} e={e} index={index} />
                );
              })}
            {((!isDoc && tabIndex === 3) || tabIndex === 4) && (
              <tr>
                <td colSpan={2}>
                  <BasicButton
                    title={t("p.new")}
                    onClick={() => handleActive({ partType: 6 }, true)}
                    type={"mini"}
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {!isPrint && <EditorBox parts={paperData.parts} />}
    </div>
  );
}
